export default __webpack_public_path__ + "static/char-s-13-en-5fb0c57376fc5889d2df5047d30070a2.png";